import { faCircleInfo, faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import parseStringToHTML from "html-react-parser";
import { ToolTipPosition } from "../utilities/frontendTypes"

function Tooltip( 
  {
    content,
    type,
    position,
    customWidth
  }
  : 
  {
    content: string,
    type?: "lock",
    position?: ToolTipPosition
    customWidth?: string
  } 
) {

  const [showTooltip, setShowTooltip] = useState(false);

  const handleShowTooltip = () => {
    setShowTooltip(true);
  };

  const handleHideTooltip = () => {
    setShowTooltip(false);
  };

  const isLock = type && type === "lock";
  //Alternatively could just change tooltipposition type to these strings
  const positionStyle = (position: ToolTipPosition) => {
    switch (position) {
      case "top-left":
        return "bottom-[50%] right-[115%]";
      case "bottom-left":
        return "top-[50%] right-[115%]";
      case "top-right":
        return "bottom-[50%] left-[115%]";
      case "bottom-right":
        return "top-[50%] left-[115%]";
    }
  }
  return (
    <button
      tabIndex={0}
      className={`tooltipIcon relative ml-3 ${isLock ? "flex items-center" : "inline-block"}`}
      onMouseEnter={handleShowTooltip}
      onMouseLeave={handleHideTooltip}
      onFocus={handleShowTooltip}
      onBlur={handleHideTooltip}
    >
      {isLock ? <FontAwesomeIcon icon={faLock} className={`z-20 text-text/70`}/> : <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Information-Circle--Streamline-Ultimate (1) 3" clipPath="url(#clip0_2274_4062)"><path id="Vector" d="M1.47266 8.49988C1.47266 10.3634 2.21292 12.1505 3.5306 13.4682C4.84827 14.7859 6.63543 15.5261 8.49891 15.5261C10.3624 15.5261 12.1495 14.7859 13.4672 13.4682C14.7849 12.1505 15.5252 10.3634 15.5252 8.49988C15.5252 6.63641 14.7849 4.84925 13.4672 3.53157C12.1495 2.2139 10.3624 1.47363 8.49891 1.47363C6.63543 1.47363 4.84827 2.2139 3.5306 3.53157C2.21292 4.84925 1.47266 6.63641 1.47266 8.49988Z" fill="#EFF5F4"/><path id="Vector_2" d="M8.49891 3.7094C10.1675 3.71043 11.7813 4.30559 13.051 5.38826C14.3207 6.47093 15.1634 7.97034 15.4281 9.61783C15.5835 8.66022 15.5388 7.68079 15.2969 6.74129C15.0549 5.8018 14.6209 4.92262 14.0223 4.15919C13.4237 3.39576 12.6734 2.76464 11.8187 2.30561C10.964 1.84658 10.0235 1.56961 9.05646 1.49215C8.08941 1.41469 7.1168 1.53843 6.19995 1.85556C5.2831 2.17269 4.4419 2.67633 3.72938 3.33474C3.01686 3.99315 2.44848 4.79204 2.06007 5.68104C1.67167 6.57004 1.47166 7.52988 1.47266 8.50002C1.47541 8.87461 1.50787 9.24838 1.56975 9.61783C1.83445 7.97034 2.67714 6.47093 3.94685 5.38826C5.21655 4.30559 6.83028 3.71043 8.49891 3.7094Z" fill="#FDFFFE"/><path id="Vector_3" d="M1.47266 8.49988C1.47266 10.3634 2.21292 12.1505 3.5306 13.4682C4.84827 14.7859 6.63543 15.5261 8.49891 15.5261C10.3624 15.5261 12.1495 14.7859 13.4672 13.4682C14.7849 12.1505 15.5252 10.3634 15.5252 8.49988C15.5252 6.63641 14.7849 4.84925 13.4672 3.53157C12.1495 2.2139 10.3624 1.47363 8.49891 1.47363C6.63543 1.47363 4.84827 2.2139 3.5306 3.53157C2.21292 4.84925 1.47266 6.63641 1.47266 8.49988Z" stroke="#1A2E25" strokeLinecap="round" strokeLinejoin="round"/><path id="Vector_4" d="M10.097 11.694H9.13891C8.9695 11.694 8.80703 11.6267 8.68724 11.5069C8.56745 11.3871 8.50016 11.2246 8.50016 11.0552V6.90336C8.50016 6.81866 8.46651 6.73742 8.40661 6.67753C8.34672 6.61763 8.26548 6.58398 8.18078 6.58398H7.22266" stroke="#1A2E25" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/><path id="Vector_5" d="M8.33547 4.9873C8.30389 4.9873 8.27301 4.99667 8.24675 5.01422C8.22049 5.03176 8.20002 5.0567 8.18794 5.08588C8.17585 5.11506 8.17269 5.14717 8.17885 5.17815C8.18501 5.20912 8.20022 5.23758 8.22255 5.25991C8.24489 5.28224 8.27334 5.29745 8.30432 5.30361C8.33529 5.30977 8.3674 5.30661 8.39658 5.29452C8.42576 5.28244 8.4507 5.26197 8.46824 5.23571C8.48579 5.20945 8.49516 5.17858 8.49516 5.14699C8.49516 5.12602 8.49103 5.10526 8.483 5.08588C8.47498 5.06651 8.46321 5.0489 8.44839 5.03408C8.43356 5.01925 8.41595 5.00749 8.39658 4.99946C8.3772 4.99144 8.35644 4.9873 8.33547 4.9873Z" stroke="#1A2E25" strokeLinecap="round" strokeLinejoin="round"/></g><defs><clipPath id="clip0_2274_4062"><rect width="16" height="16" fill="white" transform="translate(0.5 0.5)"/></clipPath></defs></svg>}
      {showTooltip && (
        <div className={`
          tooltip  ${position ? positionStyle(position) : "top-[50%] left-[115%]"}`}
        >
          <p className={customWidth ? customWidth : "" + `tooltipWidth break-words w-fit min-w-[150px]`}>{parseStringToHTML(content)}</p>
        </div>
      )}
    </button>
  );
};

export default Tooltip;
